import { t } from "@/i18n-js/instance";
import { useBillingContext } from "../BillingContext";
import { AdminApiMetric } from "./AdminApiMetric";
import { HeadlessApiMetric } from "./HeadlessApiMetric";
import { UsageDetailsSection } from "./UsageDetailsSection";

const localeRoot = "settings.billing.manage_billing.usage_details.api";

export const APIUsageDetails = () => {
  const { auxiliarySubscription } = useBillingContext();
  const apiUsage = auxiliarySubscription?.api_usage;

  if (!apiUsage?.admin && !apiUsage?.headless) {
    return null;
  }

  return (
    <UsageDetailsSection title={t(`${localeRoot}.title`)} showMenu>
      <HeadlessApiMetric details={apiUsage.headless} />
      <AdminApiMetric details={apiUsage.admin} />
    </UsageDetailsSection>
  );
};
